<template>
  <!-- operations card -->
  <div
    :class="{
      'w-full': receivedCaption,
      'lg:w-[50%] xl:w-[40%] shadow-2xl': !receivedCaption,
    }"
    class="rounded-2xl items-center justify-center mt-3"
  >
    <div
      v-if="!processingStarted && !isFromNotification && !receivedCaption"
      class="drag-drop-area w-full flex flex-col items-center justify-center rounded-2xl h-auto space-y-1"
      @dragover.prevent
      @drop.prevent="handleDrop"
    >
      <div v-if="oneTimeResultPendingOrderId" class="w-full max-w-md mx-auto flex flex-col items-center py-8 px-6 rounded-2xl bg-slate-50 border border-slate-200 shadow-sm space-y-5">
        <p class="text-lg font-semibold text-[#061B44] text-center">{{ $t("Still processing. Your result is not ready yet.") }}</p>
        <button
          type="button"
          :disabled="isFetchingOneTimeResult"
          @click="fetchOneTimeResult(oneTimeResultPendingOrderId!)"
          class="px-5 py-2.5 rounded-lg bg-[#061B44] text-white font-medium hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ $t("Retry") }}
        </button>
      </div>
      <div
        v-else-if="showOneTimePayPanel && !profileStore.hasActivePaidSubscription"
        class="w-full flex justify-center py-4"
      >
        <OneTimeAudioPay
          source-type="audio"
          :audio-link="(userInputAudioLink || '').trim()"
          :source-lang="originalLanguage?.langCode || ''"
          @cancel="showOneTimePayPanel = false"
        />
      </div>
      <template v-else>
      <!-- <img
        src="../../../assets/images/audio/01.png"
        alt=""
        class="w-[10%] lg:w-[5%]"
      /> -->
      <!-- original language gridview -->
      <div v-if="isOpen" class="overlay z-50" @click="closeList">
        <div
          class="overlay-content flex flex-col items-center min-w-[80%] h-[70%]"
          @click.stop
        >
          <div
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="flex flex-row space-x-4 w-full items-center justify-center h-10 py-4 mt-2"
          >
            <input
              v-model="searchQuery"
              @input="filteredLanguages"
              type="text"
              :placeholder="$t('search-for-a-language')"
            class="pl-1 md:pl-4 bg-white border border-slate-900 rounded-md text-slate-900 text-xs md:text-base font-semibold w-[60%] md:w-[40%] h-10"
            />
            <button
              @click="closeList"
            class="bg-white border border-slate-900 rounded-md text-slate-900 text-sm md:text-lg font-bold py-1 px-8 h-10"
            >
              {{ $t("close") }}
            </button>
          </div>
          <ul
          class="py-1 h-75vh grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-2 md:gap-4 overflow-y-auto"
          >
            <div
              v-for="lang in myLanguagesList.filter(
                (lang) => !unsupportedCloudStt.includes(lang.langCode)
              )"
              :key="lang.langName"
              class="flex flex-row space-x-2"
            >
              <a
                @click="selectLanguage(lang)"
                class="flex items-center gap-2 px-4 py-2 text-gray-800 font-semibold cursor-pointer text-sm md:text-base"
              >
                <i
                  class="pi pi-globe text-gray-500 flex-shrink-0"
                  style="font-size: 0.875rem"
                  aria-hidden="true"
                ></i>
                {{ lang.langName }}
              </a>
            </div>
          </ul>
        </div>
      </div>
      <div
        v-if="selectedAudio.name.length == 0 && !receivedCaption"
        class="container flex flex-col items-center space-y-2"
      >
        <img
          src="../../../assets/icons/upload.svg"
          alt=""
          class="w-[14%] lg:w-[5%] text-white fill-white"
        />
        <p class="text-sm md:text-lg text-slate-600 font-normal">
          {{ $t("drop-to-upload-or") }}
        </p>
        <div class="flex flex-row w-[50%] lg:w-[40%] h-10">
          <label
            for="forupload"
            class="cursor-pointer bg-[#4867C8] text-white mx-auto text-xs md:text-base font-bold px-4 md:px-10 flex items-center rounded-lg h-10"
          >
            {{ $t("choose-a-file") }}
          </label>
          <input
            type="file"
            accept=".mp3, .wav, .m4a, .aac"
            @change="handleFileChange"
            ref="fileInput"
            id="forupload"
            style="display: none"
          />
        </div>
        <p class="text-sm text-slate-900 font-bold py-1">
          {{ $t("OR") }}
        </p>
        <!-- audio link area -->
        <div
          class="white rounded-lg px-2 flex flex-col-reverse lg:flex-row justify-center h-10 bg-white border border-slate-700 items-center w-full py-10 lg:py-0"
        >
          <div class="relative group">
            <svg
              class="h-6 w-6 cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 8c-.414 0-.75.336-.75.75v5.5c0 .414.336.75.75.75s.75-.336.75-.75v-5.5c0-.414-.336-.75-.75-.75zm-.002-3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"
                fill-rule="nonzero"
              />
            </svg>

            <!-- Tooltip Div -->
            <div
              class="absolute -left-36 md:left-0 z-10 hidden p-4 text-sm text-start text-black bg-white border rounded-lg w-[300px] md:w-[420px] group-hover:block"
            >
              <p>{{ $t("examples-of-valid-links") }}</p>
              <ul class="list-disc pl-4 mt-2 text-xs md:text-sm">
                <li>{{ $t("direct-link-https-example-com-audio-mp3") }}</li>
                <!-- <li>
                  // TODO uncomment this when support drive link
                  {{
                    $t(
                      "google-drive-https-drive-google-com-file-d-file_id-view-usp-sharing"
                    )
                  }}
                </li> -->
              </ul>
              <p class="mt-2">
                {{
                  $t(
                    "make-sure-your-google-drive-link-is-set-to-anyone-with-the-link-can-view"
                  )
                }}
              </p>
            </div>
          </div>
          <input
            type="text"
            v-model="userInputAudioLink"
            @keydown.ctrl.x.exact="handleCtrlX"
            @keydown.enter.exact="() => transcriptExterneAudio()"
            :placeholder="$t('enter-direct-audio-link')"
            :class="{ 'pr-2': locale === 'ar' }"
            class="text-field w-[90%] mt-4 lg:mt-1 pb-4 h-10 text-xs md:text-base text-start white bg-white lg:bg-transparent rounded-full lg:rounded-none lg:shadow-none lg:w-full md:pl-4 pt-4 lg:pt-3 outline-none font-medium"
          />
          <div class="h-4 lg:hidden"></div>
        </div>
        <p class="font-normal text-xs md:text-sm text-slate-600 py-1">
          {{ $t("file-type-wav-mp3-m4a-aac") }} |
          {{ $t("file-size-up-to-100-mb") }} | {{ $t("max-duration-8-hours") }}
        </p>
        <div
          class="relative container w-full flex flex-row space-x-4 items-center justify-center pb-1"
        >
          <button
            v-if="!isTranslationPreview && !receivedCaption"
            @click="toggleOriginalLanguageList"
            :class="{
              'bg-slate-400': isFromNotification || receivedCaption,
              'space-x-reverse': locale === 'ar',
            }"
            class="w-full flex justify-center items-center space-x-4 bg-white h-10 p-3 rounded-lg border border-slate-900"
          >
            <p class="text-slate-900 font-medium text-sm md:text-base lg:text-lg">
              {{ $t("source-language") }}
            </p>
            <span
              v-if="originalLanguage.langName.length != 0"
              class="inline-flex items-center gap-1.5"
              :class="{ 'flex-row-reverse': locale === 'ar' }"
            >
              <i
                class="pi pi-globe text-slate-700 opacity-80 flex-shrink-0 text-sm md:text-base"
                aria-hidden="true"
              ></i>
              <span class="text-slate-900 font-medium text-base lg:text-lg">
                {{ getLanguageText() }}
              </span>
            </span>
            <img
              src="../../../assets/images/audio/02.svg"
              alt=""
              class="w-[2%] text-slate-900 fill-slate-900"
            />
          </button>
        </div>
        <div class="hidden md:block"></div>
        <!-- One-time pay path: only when user has no active paid subscription -->
        <div
          v-if="
            !oneTimeResultPendingOrderId &&
            !oneTimeUploadOrderId &&
            !profileStore.hasActivePaidSubscription
          "
          class="w-full max-w-md mx-auto flex flex-col items-center py-3 px-4 rounded-2xl bg-slate-50/80 border border-slate-200/80 mt-2"
        >
          <p class="text-sm text-slate-600 mb-2">{{ $t("No subscription?") }}</p>
          <p class="text-xs text-slate-500 text-center mb-3 max-w-sm">
            {{ $t("one-time_audio_file_flow_hint") }}
            <span class="block mt-1">{{ $t("one-time_audio_link_flow_hint") }}</span>
          </p>
          <p v-if="hasAudioLinkAndSourceLang" class="text-xs text-[#061B44] font-medium mb-2">{{ $t("one-time_audio_link_ready_hint") }}</p>
          <button
            type="button"
            @click="showOneTimePayPanel = true"
            class="px-5 py-2.5 rounded-lg bg-[#061B44] text-white font-medium hover:opacity-90 transition-opacity"
          >
            {{ hasAudioLinkAndSourceLang ? $t("Pay and transcribe") : $t("Pay once for this order") }}
          </button>
        </div>
        <button
          @click="() => transcriptExterneAudio()"
          class="button px-20 py-1 bg-subDark text-white text-sm md:text-base lg:text-lg font-bold w-full rounded-lg h-10 mt-3"
        >
          {{ $t("transcript-audio") }}
        </button>
      </div>
      <!-- file element -->
      <div class="container w-full items-center justify-center flex flex-col">
        <div
          v-if="selectedAudio.name.length != 0 && !receivedCaption"
          class="relative container w-full flex flex-row space-x-4 items-center justify-center pb-4"
        >
          <button
            @click="toggleOriginalLanguageList"
            :class="{ 'bg-slate-400': isFromNotification || receivedCaption }"
            class="w-full flex justify-center items-center space-x-4 bg-white h-10 p-3 rounded-lg border border-slate-900"
          >
            <p class="text-slate-900 font-medium text-sm md:text-base lg:text-lg">
              {{ $t("source-language") }}
            </p>
            <span
              v-if="originalLanguage.langName.length != 0"
              class="inline-flex items-center gap-1.5"
              :class="{ 'flex-row-reverse': locale === 'ar' }"
            >
              <i
                class="pi pi-globe text-slate-700 opacity-80 flex-shrink-0 text-sm md:text-base"
                aria-hidden="true"
              ></i>
              <span class="text-slate-900 font-medium text-sm md:text-base lg:text-lg">
                {{ getLanguageText() }}
              </span>
            </span>
            <img
              src="../../../assets/images/audio/02.svg"
              alt=""
              class="w-[3%] text-white fill-white"
            />
          </button>
        </div>
        <div
          v-if="selectedAudio.name.length != 0 && !receivedCaption"
          class="flex flex-row items-center justify-between px-2 w-full rounded-lg border border-slate-900 h-10"
        >
          <div class="flex flex-row max-w-[95%]">
            <img src="../../../assets/images/audio/file.svg" class="w-6" />
            <p
              class="truncate text-base lg:text-lg pl-2 text-slate-900 font-medium"
            >
              {{ selectedAudio.name }}
            </p>
          </div>
          <div
            @click="removeFile"
            class="min-w-6 h-6 rounded-full bg-red-100 hover:bg-red-300 flex items-center justify-center cursor-pointer text-red-500 transition-colors duration-200"
            role="button"
            aria-label="Remove file"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </div>
        <div
          v-if="
            selectedAudio.name.length != 0 &&
            !receivedCaption &&
            !isFromNotification
          "
          class="container pt-4"
        >
          <!-- <p
            v-if="!computePricing && balanceNotEnough"
            class="text-base pl-4 text-red-600 font-medium"
          >
            {{
              $t(
                "this-selected-audio-file-will-incur-a-charge-of-audiotranscriptioncost-for-transcription-services",
                { audioTranscriptionCost }
              )
            }}
          </p> -->
          <!-- <div
            v-if="balanceNotEnough && !computePricing"
            class="text-base pl-4 text-red-600 font-medium"
          >
            <p class="text-base pl-4 text-red-600 font-medium">
              {{
                $t("your-balance-is-insufficient-please-recharge-to-continue")
              }}
            </p>
            <button
              @click="navToPayment"
              class="text-lg font-bold text-blue-600"
            >
              {{ $t("clicking-here") }}
            </button>
          </div> -->

          <!-- <p
            v-if="computePricing"
            class="text-base pl-4 text-[#2152B6] font-medium"
          >
            {{ $t("calculating-file-transcription-cost-please-wait") }}
          </p> -->
        </div>
        <!-- translation language gridview -->
        <div v-if="isTargetListOpen" class="overlay z-50" @click="closeList">
          <div
            class="overlay-content flex flex-col items-center min-w-[80%] h-[70%]"
            @click.stop
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row space-x-4 w-full items-center justify-center h-10 py-4 mt-2"
            >
              <input
                v-model="searchQuery"
                @input="filteredLanguages"
                type="text"
                :placeholder="$t('search-for-a-language')"
                class="pl-4 bg-white border border-slate-900 rounded-md text-slate-900 text-base font-semibold w-[40%] h-10"
              />
              <button
                @click="closeList"
                class="bg-white border border-slate-900 rounded-md text-slate-900 text-lg font-bold py-1 px-8 h-10"
              >
                {{ $t("close") }}
              </button>
            </div>
            <ul
              class="py-1 h-75vh grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto"
            >
              <li
                v-for="lang in myLanguagesList"
                :key="lang.langName"
                class="flex flex-row space-x-2"
              >
                <a
                  @click="selectTargetLanguage(lang)"
                  class="flex items-center gap-2 px-4 py-2 text-gray-800 font-semibold cursor-pointer"
                >
                  <i
                    class="pi pi-globe text-gray-500 flex-shrink-0"
                    style="font-size: 0.875rem"
                    aria-hidden="true"
                  ></i>
                  {{ lang.langName }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-if="selectedAudio.name.length != 0 && !receivedCaption"
          class="flex flex-row space-x-4 items-center justify-center w-full"
        >
          <button
            @click="startProcessing"
            class="button px-20 py-1 bg-subDark text-base lg:text-lg font-bold w-full rounded-lg h-10"
          >
            <p class="text-white font-semibold text-sm md:text-base lg:text-lg">
              {{ $t("process-audio-file") }}
            </p>
          </button>
        </div>
      </div>
      <!-- todo -->
      </template>
    </div>
    <!-- processing status -->
    <div
      v-if="processingStarted && !receivedCaption && !notReadyYet"
      class="flex flex-col justify-center items-center space-y-2 h-auto py-12 p-4 md:p-0 md:py-12"
    >
      <img
        class="w-12 h-12 lg:w-20 lg:h-20 animate-spin fill-[#061B44]"
        src="../../../assets/icons/loading-loader.svg"
        alt="Loading icon"
      />
      <p class="text-base md:text-xl lg:text-2xl text-slate-900 text-center font-semibold">
        {{ processingStatus }}
      </p>
      <div
        v-if="!processingLink"
        class="bg-gray-400 rounded-full h-2.5 w-[80%] lg:w-[70%]"
      >
        <div
          class="bg-blue-700 h-2.5 rounded-full"
          :style="{ width: `${progressBar}%` }"
        ></div>
      </div>
      <p
        v-if="!processingLink"
        class="text-sm md:text-base lg:text-xl text-slate-900 text-center font-medium"
      >
        {{ $t("this-may-take-a-minute-hang-tight") }}
      </p>
      <p
        v-if="!processingLink"
        class="text-sm md:text-base lg:text-xl text-slate-900 text-center font-medium"
      >
        {{ selectedAudio.name }}
      </p>
    </div>
    <!-- comeback later -->
    <div
      v-if="processingStarted && !receivedCaption && notReadyYet"
      class="flex flex-col justify-center items-center space-y-2 h-auto py-12"
    >
      <img
        class="w-32 h-32 lg:w-40 lg:h-40 fill-[#061B44]"
        src="../../../assets/images/youtube/01.png"
        alt="Loading icon"
      />
      <p
        class="text-sm pt-10 lg:text-base text-[#061B44] text-center font-medium"
      >
        {{ $t("Your_audio_was_sent_to_our_service_You_will_be") }}
      </p>
      <p class="text-sm lg:text-base text-[#061B44] text-center font-medium">
        {{
          $t(
            "thank-you-for-using-our-service-feel-free-to-continue-exploring-our-services"
          )
        }}
        <router-link to="/orders" class="font-semibold text-[#6193F6]">{{
          $t("Orderspage")
        }}</router-link>
      </p>
      <p class="text-sm lg:text-base text-[#061B44] text-center font-medium">
        {{ $t("if-youd-like-to-return-to-the-home-page-simply-follow") }}
        <button @click="goBackToMainPage" class="font-semibold text-[#6193F6]">
          {{ $t("the-link-below") }}
        </button>
      </p>
    </div>
    <AudioProcessingResult />
  </div>
  <!-- user consume solde -->
  <div
    v-if="showPaymentModal"
    class="overlay bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
      <div class="flex flex-row text-xl items-center mb-4 space-x-1">
        <i class="pi pi-credit-card text-blue-500 text-center"></i>
        <h3 class="font-semibold">{{ $t("complete-your-translation") }}</h3>
      </div>
      <p class="text-gray-700 mb-6">{{ modalMessage }}</p>
      <div class="flex justify-end space-x-4">
        <button
          @click="handleModalResponse(false)"
          class="mt-4 bg-white text-slate-900 border-slate-400 border-[1px] h-9 py-1 px-10 rounded-md font-normal text-base"
        >
          {{ t("cancel") }}
        </button>
        <button
          @click="handleModalResponse(true)"
          class="mt-4 text-white bg-slate-900 h-9 py-1 px-10 rounded-md font-normal text-base flex items-center space-x-2"
        >
          <p>{{ $t("continue") }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.drag-drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

.text-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px;
  z-index: 999;
}
.videoplay {
  width: 70%;
  height: 100%;
}
</style>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from "vue";
import { useAudioStore } from "../../../store/audioStore";
import { useUserProfile } from "../../../store/userProfile";
import { useUserActivities } from "../../../store/userActivities";
import {
  Language,
  languages,
  unsupportedCloudStt,
} from "../../../utils/languageList";
import {
  API_BASE_URL,
  TRANSCRIPT_AUDIO,
  TRANSCRIPT_AUDIO_SONIOX,
  GETPRICES,
  TRANSCRIPTEXTERNAUDIO,
  GOOGLEDRIVEAUDIO,
  GETTRANSAUDIOFILE,
  GETTRANSLATEDTEXT,
  GENERATEUPLOADURL,
  SUMMARIZETEXT,
  ONETIME_AUDIO_UPLOAD_URL,
  ONETIME_AUDIO_CONFIRM_UPLOAD,
  ONETIME_AUDIO_RESULT as ONETIME_AUDIO_RESULT_API,
} from "../../../utils/appConst";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "../../../store/auth";
import { useRoute, useRouter } from "vue-router";
import { toBlobURL } from "@ffmpeg/util";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { CaptionModel } from "../../../utils/captionModel";
import AudioProcessingResult from "../../modules/audio/audio_processing_result.vue";
import OneTimeAudioPay from "./one_time_audio_pay.vue";
import { SubscriptionType } from "../../../utils/subscriptionModel";
import servicesPricing from "../../../utils/servicesPricing";
import {
  parseWebVTTToCaption,
  convertCaptionToWebVTT,
  segmentsListForCaptions,
  type CaptionItem,
} from "../../../utils/webvtt";
import { useHead } from "@vueuse/head";

const route = useRoute();
const router = useRouter();
const activitesStore = useUserActivities();
const transcriptAudioUrl = `${API_BASE_URL}${TRANSCRIPT_AUDIO}`;
const generateUploadUrl = `${API_BASE_URL}${GENERATEUPLOADURL}`;
const getPrices = `${API_BASE_URL}${GETPRICES}`;
const transcriptExterneAudioUrl = `${API_BASE_URL}${TRANSCRIPTEXTERNAUDIO}`;
const transcriptGoogleDriveAudioUrl = `${API_BASE_URL}${GOOGLEDRIVEAUDIO}`;
const getTranscriptionFile = `${API_BASE_URL}${GETTRANSAUDIOFILE}`;
const getTranslatedFileUrl = `${API_BASE_URL}${GETTRANSLATEDTEXT}`;
const summarizeTextUrl = `${API_BASE_URL}${SUMMARIZETEXT}`;
const ffmpegbaseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/esm";
const as = useAudioStore();
const authStore = useAuthStore();
const profileStore = useUserProfile();
const { t, locale } = useI18n();
const ffmpeg = new FFmpeg();
const showPaymentModal = ref(false);
const isPaymentProcessingLink = ref(false);
const modalMessage = ref("");
const showOneTimePayPanel = ref(false);
watch(
  () => profileStore.hasActivePaidSubscription,
  (active) => {
    if (active) showOneTimePayPanel.value = false;
  }
);
const oneTimeUploadOrderId = ref<string | null>(null);
const oneTimeUploadDone = ref(false);
const oneTimeUploading = ref(false);
const oneTimeUploadError = ref("");
const oneTimeUploadSourceLang = ref("");
const oneTimeResultPendingOrderId = ref<string | null>(null);
const isFetchingOneTimeResult = ref(false);
let webVttData = "";
let durationInUnits = 0;

// Speaker color configuration for diarization
const SPEAKER_COLORS: Record<number, string> = {
  1: '#4867D3',  // Primary blue
  2: '#10B981',  // Green
  3: '#F59E0B',  // Orange
  4: '#EF4444',  // Red
  5: '#8B5CF6',  // Purple
  6: '#EC4899',  // Pink
  7: '#06B6D4',  // Cyan
  8: '#84CC16',  // Lime
  9: '#F97316',  // Orange-red
  10: '#6366F1'  // Indigo
};

// Fallback color if speaker tag is missing
const DEFAULT_SPEAKER_COLOR = '#1E293B'; // Dark gray
const processingStarted = computed({
  get: () => as.processingStarted,
  set: (value) => (as.processingStarted = value),
});
const originalJsonContent = computed({
  get: () => as.originalJsonContent,
  set: (value) => (as.originalJsonContent = value),
});
const receivedCaption = computed({
  get: () => as.receivedCaption,
  set: (value) => (as.receivedCaption = value),
});
const isFromNotification = computed({
  get: () => as.isFromNotification,
  set: (value) => (as.isFromNotification = value),
});
const isTargetListOpen = computed({
  get: () => as.isTargetListOpen,
  set: (value) => (as.isTargetListOpen = value),
});
const selectedAudio = computed({
  get: () => as.selectedAudio,
  set: (value) => (as.selectedAudio = value),
});
const userInputAudioLink = computed({
  get: () => as.userInputAudioLink,
  set: (value) => (as.userInputAudioLink = value),
});

const isTranslationPreview = computed({
  get: () => as.isTranslationPreview,
  set: (value) => (as.isTranslationPreview = value),
});
const isOpen = computed({
  get: () => as.isOpen,
  set: (value) => (as.isOpen = value),
});
const myLanguagesList = computed({
  get: () => as.myLanguagesList,
  set: (value) => (as.myLanguagesList = value),
});
const searchQuery = computed({
  get: () => as.searchQuery,
  set: (value) => (as.searchQuery = value),
});
const originalLanguage = computed({
  get: () => as.originalLanguage,
  set: (value) => (as.originalLanguage = value),
});
const hasAudioLinkAndSourceLang = computed(() => {
  const link = typeof as.userInputAudioLink === "string" ? as.userInputAudioLink.trim() : "";
  const lang = as.originalLanguage?.langCode;
  return link.length > 0 && !!lang && String(lang).trim().length > 0;
});
const computePricing = computed({
  get: () => as.computePricing,
  set: (value) => (as.computePricing = value),
});
const balanceNotEnough = computed({
  get: () => as.balanceNotEnough,
  set: (value) => (as.balanceNotEnough = value),
});
const isTargetLanguageSelected = computed({
  get: () => as.isTargetLanguageSelected,
  set: (value) => (as.isTargetLanguageSelected = value),
});
const audioContent = computed({
  get: () => as.audioContent,
  set: (value) => (as.audioContent = value),
});
const textTranslationPrice = computed({
  get: () => as.textTranslationPrice,
  set: (value) => (as.textTranslationPrice = value),
});
const notReadyYet = computed({
  get: () => as.notReadyYet,
  set: (value) => (as.notReadyYet = value),
});
const processingStatus = computed({
  get: () => as.processingStatus,
  set: (value) => (as.processingStatus = value),
});
const progressBar = computed({
  get: () => as.progressBar,
  set: (value) => (as.progressBar = value),
});
const currentRequestId = computed({
  get: () => as.currentRequestId,
  set: (value) => (as.currentRequestId = value),
});
const originalText = computed({
  get: () => as.originalText,
  set: (value) => (as.originalText = value),
});
const translatedText = computed({
  get: () => as.translatedText,
  set: (value) => (as.translatedText = value),
});
const ffmpegPercentage = computed({
  get: () => as.ffmpegPercentage,
  set: (value) => (as.ffmpegPercentage = value),
});
const fileUploadPercentage = computed({
  get: () => as.fileUploadPercentage,
  set: (value) => (as.fileUploadPercentage = value),
});
const fileUploaded = computed({
  get: () => as.fileUploaded,
  set: (value) => (as.fileUploaded = value),
});
const translationLanguage = computed({
  get: () => as.translationLanguage,
  set: (value) => (as.translationLanguage = value),
});
const defaultOriginalText = computed({
  get: () => as.defaultOriginalText,
  set: (value) => (as.defaultOriginalText = value),
});
const defaultTranslatedText = computed({
  get: () => as.defaultTranslatedText,
  set: (value) => (as.defaultTranslatedText = value),
});
const defaultOriginalAudioSubtitle = computed({
  get: () => as.defaultOriginalAudioSubtitle,
  set: (value) => (as.defaultOriginalAudioSubtitle = value),
});
const defaultTranslatedAudioSubtitle = computed({
  get: () => as.defaultTranslatedAudioSubtitle,
  set: (value) => (as.defaultTranslatedAudioSubtitle = value),
});
const prebuildAudioSubtitle = computed({
  get: () => as.prebuildAudioSubtitle,
  set: (value) => (as.prebuildAudioSubtitle = value),
});
const originalAudioSubtitle = computed({
  get: () => as.originalAudioSubtitle,
  set: (value) => (as.originalAudioSubtitle = value),
});
const translatedAudioSubtitle = computed({
  get: () => as.translatedAudioSubtitle,
  set: (value) => (as.translatedAudioSubtitle = value),
});
const processingLink = computed({
  get: () => as.processingLink,
  set: (value) => (as.processingLink = value),
});
const summarizesData = computed({
  get: () => as.summarizesData,
  set: (value) => (as.summarizesData = value),
});
const translatedSummarizesLangs = computed({
  get: () => as.translatedSummarizesLangs,
  set: (value) => (as.translatedSummarizesLangs = value),
});
const latestTranslationId = computed({
  get: () => as.latestTranslationId,
  set: (value) => (as.latestTranslationId = value),
});
const goBackToMainPage = () => {
  if (notReadyYet.value && processingStarted.value) {
    notReadyYet.value = false;
    processingStarted.value = false;
    processingLink.value = false;
    selectedAudio.value = { name: "", data: null };
  }
};

onMounted(async () => {
  if (route.query.onetime === "success" && route.query.orderId) {
    const orderId = route.query.orderId.toString();
    const hadAudioLink = typeof sessionStorage !== "undefined" && sessionStorage.getItem("onetime_audio_link");
    console.log("[OneTimeAudioLink] Return from PayPal, showing order under process orderId=", orderId, "hadAudioLink=", !!hadAudioLink);
    if (hadAudioLink) {
      oneTimeUploadOrderId.value = orderId;
      oneTimeUploadError.value = "";
      oneTimeUploadSourceLang.value = "";
      oneTimeUploadDone.value = true;
      notReadyYet.value = true;
      processingStarted.value = true;
      try {
        sessionStorage.removeItem("onetime_audio_link");
        sessionStorage.removeItem("onetime_audio_sourceLang");
      } catch (_) {}
    } else {
      oneTimeUploadOrderId.value = orderId;
      oneTimeUploadDone.value = false;
      oneTimeUploadError.value = "";
      oneTimeUploadSourceLang.value = "";
      toast.success(t("Payment successful. You will receive a notification to upload your file."));
    }
  } else if (route.query.onetime === "success") {
    toast.success(t("Payment successful. You will receive a notification to upload your file."));
  }
  if (route.query.onetime === "cancelled") {
    toast(t("Payment was cancelled."), { type: "info", theme: "light" });
  }
  if (!ffmpeg.loaded) {
    console.log("Preloading FFmpeg...");
    await ffmpeg.load({
      coreURL: await toBlobURL(
        `${ffmpegbaseURL}/ffmpeg-core.js`,
        "text/javascript"
      ),
      wasmURL: await toBlobURL(
        `${ffmpegbaseURL}/ffmpeg-core.wasm`,
        "application/wasm"
      ),
    });
    console.log("FFmpeg preloaded!");
  }
});

// No polling: backend sends notification when one-time result is ready; user opens from notification.

const processNewAudio = () => {
  console.log("new process here -----------------------");
  if (notReadyYet.value) {
    receivedCaption.value = false;
    processingStarted.value = false;
    notReadyYet.value = false;
    originalText.value = "";
    translatedText.value = "";
    defaultOriginalText.value = "";
    defaultTranslatedText.value = "";
    selectedAudio.value.name = "";
    userInputAudioLink.value = "";
    originalAudioSubtitle.value = "";
    translatedAudioSubtitle.value = "";
    prebuildAudioSubtitle.value = "";
    defaultOriginalAudioSubtitle.value = "";
    defaultTranslatedAudioSubtitle.value = "";
    isFromNotification.value = false;
    latestTranslationId.value = "";
    isTargetLanguageSelected.value = false;
    oneTimeUploadOrderId.value = null;
    oneTimeResultPendingOrderId.value = null;
    oneTimeUploadSourceLang.value = "";
  }
  audioContent.value = "";
  as.audioContentTranslated = "";
};

const getTranslatedFile = async (fileId: string) => {
  try {
    if (!fileId) {
      return;
    }
    const response = await fetch(getTranslatedFileUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        reqId: fileId,
      }),
    });
    const r = await response.json();
    if (!response.ok) {
      switch (r.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
    }
    originalText.value = r.translatedText.originalText;
    defaultOriginalText.value = r.translatedText.originalText;
    const orLang = languages.find(
      (language) => language.langCode === r.originalLanguage
    ) || {
      langName: "English",
      langCode: "en",
      countryCode: "us",
    };
    originalLanguage.value = orLang;
    const trLang = languages.find(
      (language) => language.langCode === r.targetLamguage
    ) || {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    };
    translationLanguage.value = trLang;
    const text = r.translatedText?.translatedText ?? "";
    translatedText.value = text;
    defaultTranslatedText.value = text;
    console.log("[Translation][Audio] getTranslatedFile: text translation length=", text.length, "preview=", text.slice(0, 500) + (text.length > 500 ? "…" : ""));
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const fetchSummarizedText = async () => {
  try {
    const getData = await fetch(
      `${summarizeTextUrl}/${currentRequestId.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      }
    );

    const data = await getData.json();

    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
    }

    if (getData.status === 200 && data.results) {
      as.summarizesData = data.results;
      as.selectedSummarizedLanguage =
        translatedSummarizesLangs.value.length === 0
          ? translationLanguage.value.langCode
          : translatedSummarizesLangs.value[0];
      as.originalSummarizedText = summarizesData.value.find(
        (e: any) => e.lang === originalLanguage.value.langCode
      )?.summary;
      as.translatedSummarizedText =
        summarizesData.value.find(
          (e: any) => e.lang === translationLanguage.value.langCode
        )?.summary || "";
    }
  } catch (error) {
    as.originalSummarizedText = "";
    console.log(`fetchSummarizedText: ${error}`);
  }
};

const fetchTranscription = async (reqId: string, audioType: string) => {
  try {
    currentRequestId.value = reqId;
    const getData = await fetch(getTranscriptionFile, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        reqId: reqId,
        type: audioType,
      }),
    });
    const data = await getData.json();
    
    // Log transcription file loading status and format
    
    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      processNewAudio();
      receivedCaption.value = false;
    }

    // Handle both array and single object formats
    if (Array.isArray(data.result) || (data.result && typeof data.result === 'object')) {
      // Normalize result to always work with the actual data
      let resultData = data.result;
      if (Array.isArray(data.result)) {
        if (data.result.length === 0) {
          console.error("Result array is empty");
          return;
        }
        resultData = data.result[0];
      }
      
      receivedCaption.value = true;
      originalJsonContent.value = JSON.stringify(data.result);
      
      // Extract text based on format
      if (isSonioxFormat(resultData)) {
        // Use new Soniox-specific extraction method
        originalText.value = extractTextFromSoniox(resultData);
        defaultOriginalText.value = extractTextFromSoniox(resultData);
      } else {
        // Use original method for Google Cloud format
        const extractData = Array.isArray(data.result) ? data.result : [data.result];
        originalText.value = extractText(extractData);
        defaultOriginalText.value = extractText(extractData);
      }
      
      // Detect format and use appropriate parser
      if (isSonioxFormat(resultData)) {
        try {
          prebuildAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          originalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          as.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
        } catch (error) {
          console.error("Error parsing Soniox format:", error);
        }
      } else {
        try {
          // Google Cloud format expects an array
          const googleData = Array.isArray(data.result) ? data.result : [data.result];
          prebuildAudioSubtitle.value = subtitleGeneration(googleData);
          originalAudioSubtitle.value = subtitleGeneration(googleData);
          defaultOriginalAudioSubtitle.value = subtitleGeneration(googleData);
          as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(googleData);
        } catch (error) {
          console.error("Error parsing Google Cloud format:", error);
        }
      }
      const orLang = languages.find(
        (language) => language.langCode === data.originalLang
      ) || {
        langName: "English",
        langCode: "en",
        countryCode: "us",
      };
      originalLanguage.value = orLang;
    }
  } catch (error) {
    console.log(`fetchTranscription: ${error}`);
  }
};

const fetchOneTimeResult = async (orderId: string) => {
  try {
    isFetchingOneTimeResult.value = true;
    const res = await fetch(
      `${API_BASE_URL}${ONETIME_AUDIO_RESULT_API}?orderId=${encodeURIComponent(orderId)}`,
      {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }
    );
    const data = await res.json();
    if (!res.ok) {
      if (res.status === 202) {
        oneTimeResultPendingOrderId.value = orderId;
        return;
      }
      throw new Error(data.error || "Failed to load result");
    }
    oneTimeResultPendingOrderId.value = null;
    receivedCaption.value = true;
    isFromNotification.value = true;
    if (data.fileTitle && String(data.fileTitle).trim()) {
      const name = String(data.fileTitle).trim();
      as.fileName = name;
      selectedAudio.value.name = "";
      selectedAudio.value.data = null;
      console.log("[OneTimeResult][Audio] orderId=", orderId, "fileTitle hint for preview (as.fileName):", name);
    } else {
      console.log("[OneTimeResult][Audio] orderId=", orderId, "no fileTitle in response, fileTitle=", data.fileTitle);
    }
    originalJsonContent.value = JSON.stringify(data.result);
    const resultType = Array.isArray(data.result) ? "array" : typeof data.result;
    const resultKeys = data.result && typeof data.result === "object" && !Array.isArray(data.result) ? Object.keys(data.result).slice(0, 10) : [];
    console.log("[OneTimeResult][FE] orderId=", orderId, "result type=", resultType, "result keys=", resultKeys, "hasResult=", !!data.result);
    let resultData = data.result;
    if (Array.isArray(data.result) && data.result.length > 0) {
      resultData = data.result[0];
    }
    if (resultData) {
      if (isSonioxFormat(resultData)) {
        originalText.value = extractTextFromSoniox(resultData);
        defaultOriginalText.value = extractTextFromSoniox(resultData);
        try {
          prebuildAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          originalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(resultData);
          as.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
        } catch (err) {
          console.error("[OneTimeResult][FE] Soniox subtitle parse error:", err);
        }
      } else {
        const extractData = Array.isArray(data.result) ? data.result : [data.result];
        originalText.value = extractText(extractData);
        defaultOriginalText.value = extractText(extractData);
        try {
          const googleData = Array.isArray(data.result) ? data.result : [data.result];
          prebuildAudioSubtitle.value = subtitleGeneration(googleData);
          originalAudioSubtitle.value = subtitleGeneration(googleData);
          defaultOriginalAudioSubtitle.value = subtitleGeneration(googleData);
          as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(googleData);
        } catch (err) {
          console.error("[OneTimeResult][FE] Google subtitle parse error:", err);
        }
      }
    }
    const hasTranslation = data.translation != null;
    console.log("[OneTimeResult][FE] orderId=", orderId, "translation present=", !!data.translation, "segments.length=", data.translation?.segments?.length, "voiceOverUrl=", !!data.voiceOverUrl);
    if (hasTranslation) {
      const rawOriginalWebVTT = originalAudioSubtitle.value || "";
      const originalCaptions = parseWebVTTToCaption(rawOriginalWebVTT);
      console.log("[Caption][FE] original WebVTT length=", rawOriginalWebVTT.length, "originalCaptions count=", originalCaptions.length, "originalCaptions texts=", originalCaptions.map((c, i) => `#${i}: "${(c.text || "").slice(0, 80)}${(c.text || "").length > 80 ? "…" : ""}"`));
      const rawSegments = data.translation.segments;
      const segmentsList = segmentsListForCaptions(rawSegments, originalCaptions);
      console.log("[Caption][FE] raw translation.segments count=", Array.isArray(rawSegments) ? rawSegments.length : (rawSegments != null ? 1 : 0), "raw segments texts=", Array.isArray(rawSegments) ? rawSegments.map((s: unknown, i: number) => `#${i}: "${String(s ?? "").slice(0, 80)}${String(s ?? "").length > 80 ? "…" : ""}"`) : [String(rawSegments ?? "").slice(0, 80)]);
      console.log("[Caption][FE] segmentsList count=", segmentsList.length, "segmentsList texts=", segmentsList.map((t, i) => `#${i}: "${t.slice(0, 80)}${t.length > 80 ? "…" : ""}"`));
      if (segmentsList.length > 0) {
        const translationText = segmentsList.join("\n");
        defaultTranslatedText.value = translationText;
        translatedText.value = translationText;
        console.log("[Translation][Audio] text translation length=", translationText.length, "preview=", translationText.slice(0, 500) + (translationText.length > 500 ? "…" : ""));
        if (data.targetLang && originalCaptions.length > 0) {
          // When translation has more segments than original captions (e.g. 2 segments, 1 caption),
          // merge segment texts so we don't drop any (one-to-one by index would use only segmentsList[0]).
          const translatedCaptions: CaptionItem[] = originalCaptions.map((cap, i) => {
            let text: string;
            if (segmentsList.length > originalCaptions.length) {
              const startIdx = Math.round((i * segmentsList.length) / originalCaptions.length);
              const endIdx = Math.round(((i + 1) * segmentsList.length) / originalCaptions.length);
              const parts = segmentsList.slice(startIdx, endIdx).filter(Boolean);
              text = parts.length > 0 ? parts.join(" ") : (segmentsList[i] ?? segmentsList[segmentsList.length - 1] ?? cap.text);
            } else {
              text = segmentsList[i] ?? segmentsList[segmentsList.length - 1] ?? cap.text;
            }
            return { ...cap, text };
          });
          console.log("[Caption][FE] translatedCaptions count=", translatedCaptions.length, "translatedCaptions texts=", translatedCaptions.map((c, i) => `#${i}: "${(c.text || "").slice(0, 80)}${(c.text || "").length > 80 ? "…" : ""}"`));
          const webvtt = convertCaptionToWebVTT(translatedCaptions);
          console.log("[Translation][Audio] caption translation: webvtt length=", webvtt.length, "preview=", webvtt.slice(0, 500) + (webvtt.length > 500 ? "…" : ""));
          translatedAudioSubtitle.value = webvtt;
          defaultTranslatedAudioSubtitle.value = webvtt;
        }
      }
    }
    if (data.voiceOverUrl) {
      as.audioContentTranslated = data.voiceOverUrl;
    }
    // Use language already selected at payment so user does not re-select
    if (data.originalLang) {
      const orLang = languages.find(
        (language: { langCode: string }) => language.langCode === data.originalLang
      ) || {
        langName: "English",
        langCode: "en",
        countryCode: "us",
      };
      originalLanguage.value = orLang;
    }
    if (data.targetLang) {
      const targetLangInfo = languages.find(
        (l: { langCode: string }) => l.langCode === data.targetLang || (typeof l.langCode === "string" && l.langCode.startsWith((data.targetLang || "").split("-")[0]))
      );
      if (targetLangInfo) translationLanguage.value = { ...targetLangInfo };
    }
    notReadyYet.value = false;
    console.log("[OneTimeResult][FE] orderId=", orderId, "after assign: originalText.length=", originalText.value?.length ?? 0, "defaultOriginalText.length=", defaultOriginalText.value?.length ?? 0, "translatedText.length=", translatedText.value?.length ?? 0);
  } catch (e) {
    console.error("fetchOneTimeResult:", e);
    toast(t("were-fixing-a-technical-issue-so-please-try"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
  } finally {
    isFetchingOneTimeResult.value = false;
  }
};

// When user starts a new transcription (e.g. from parent), receivedCaption becomes false;
// clear one-time state so the "Pay once for this order" button is visible again.
watch(receivedCaption, (val) => {
  if (!val) {
    oneTimeUploadOrderId.value = null;
    oneTimeResultPendingOrderId.value = null;
    showOneTimePayPanel.value = false;
    oneTimeUploadSourceLang.value = "";
  }
});

// One-time flow: when URL has type=onetime_upload or onetime_result (backend sends notification when ready).
watch(
  () => [route.query.type, route.query.onetime_order],
  async () => {
    const queryType = route.query.type?.toString();
    const onetimeOrderId = route.query.onetime_order?.toString();
    const reqId = route.query.req?.toString();

    if (queryType === "onetime_upload" || queryType === "onetime_result") {
      const orderId = onetimeOrderId || reqId;
      if (!orderId) return;
      if (queryType === "onetime_upload") {
        processNewAudio();
        processingStarted.value = false;
        receivedCaption.value = false;
        isFromNotification.value = false;
        oneTimeUploadOrderId.value = orderId;
        oneTimeUploadDone.value = false;
        oneTimeUploadError.value = "";
        oneTimeUploadSourceLang.value = "";
        return;
      }
      if (queryType === "onetime_result") {
        processNewAudio();
        processingStarted.value = false;
        receivedCaption.value = false;
        isFromNotification.value = false;
        await fetchOneTimeResult(orderId);
        return;
      }
    }
  },
  { immediate: true }
);

// Legacy: when URL has req= or text= (notification link); backend sends notification when ready.
watch(
  () => route.query.req,
  async () => {
    if (!route.query.req) return;
    notReadyYet.value = true;
    console.log("watch -----------------------");
    processNewAudio();
    if (route.query.req) {
      const reqId = route.query.req.toString();
      const audioType = route.query.link ? "EXTAUDIO" : "AUDIO";
      await fetchTranscription(reqId, audioType);
      await fetchSummarizedText();
      if (route.query.tr) {
        const relatedRequestId = route.query.tr.toString();
        await getTranslatedFile(relatedRequestId || "");
      }
      isFromNotification.value = true;
    } else if (route.query.text) {
      const reqId = route.query.text.toString();
      isTranslationPreview.value = true;
      await getTranslatedFile(reqId);
      isFromNotification.value = true;
      receivedCaption.value = true;
    }
  },
  { immediate: true }
);

const oneTimeUploadFile = async (file: File) => {
  const orderId = oneTimeUploadOrderId.value;
  if (!orderId || !authStore.token) return;
  oneTimeUploadError.value = "";
  oneTimeUploading.value = true;
  processingStarted.value = true;
  if (notReadyYet.value) notReadyYet.value = false;
  try {
    const urlRes = await fetch(
      `${API_BASE_URL}${ONETIME_AUDIO_UPLOAD_URL}?orderId=${encodeURIComponent(orderId)}`,
      { headers: { Authorization: `Bearer ${authStore.token}` } }
    );
    const { url, fileName } = await urlRes.json();
    if (!url || !fileName) throw new Error("Failed to get upload URL");
    const blob = new Blob([await file.arrayBuffer()], { type: "audio/wav" });
    const putRes = await fetch(url, {
      method: "PUT",
      body: blob,
      headers: { "Content-Type": "audio/wav" },
    });
    if (!putRes.ok) throw new Error("Upload failed");
    const sourceLang = oneTimeUploadSourceLang.value?.trim();
    if (!sourceLang) throw new Error("Source language is required");
    const confirmRes = await fetch(`${API_BASE_URL}${ONETIME_AUDIO_CONFIRM_UPLOAD}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
      },
      body: JSON.stringify({ orderId, fileName, sourceLang, originalFileName: file.name || undefined }),
    });
    const confirmData = await confirmRes.json();
    if (!confirmRes.ok) throw new Error(confirmData.error || "Confirm failed");
    oneTimeUploadDone.value = true;
    notReadyYet.value = true;
  } catch (e) {
    oneTimeUploadError.value = (e as Error).message || "Upload failed";
  } finally {
    oneTimeUploading.value = false;
    if (!oneTimeUploadDone.value) processingStarted.value = false;
  }
};

const toggleOriginalLanguageList = () => {
  if (receivedCaption.value || isFromNotification.value) {
    return;
  }
  isOpen.value = !isOpen.value;
};

const getLanguageText = () => {
  return (
    removeParentheses(originalLanguage.value.langName) || "Original Language"
  );
};

const removeParentheses = (langName: string) => {
  return langName.replace(/\s*\(.*?\)\s*/g, "").trim();
};

const closeList = () => {
  isOpen.value = false;
  isTargetListOpen.value = false;
  resetFilter();
};

const filteredLanguages = () => {
  if (searchQuery.value.length == 0) {
    myLanguagesList.value = languages;
  } else {
    const lowerCaseQuery = searchQuery.value.toLowerCase();
    myLanguagesList.value = languages.filter((langs) =>
      langs.langName.toLowerCase().includes(lowerCaseQuery)
    );
  }
};

const resetFilter = () => {
  searchQuery.value = "";
  myLanguagesList.value = languages;
};

const selectLanguage = (lang: Language) => {
  originalLanguage.value = { ...lang };
  isOpen.value = false;
};

const handleDrop = (event: any) => {
  const file = event.dataTransfer.files[0];

  if (file.size > 500 * 1024 * 1024) {
    toast(t("error-file-size-exceeds-500mb"), {
      autoClose: 2500,
      type: "error",
      theme: "light",
    });
    return;
  }

  if (file && file.type.startsWith("audio/")) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileContent = e.target?.result;
      const audioElement = document.createElement("audio");
      const objectURL = URL.createObjectURL(file);
      audioElement.src = objectURL;
      audioElement.addEventListener("loadedmetadata", () => {
        const durationInSeconds = audioElement.duration;
        const maxDurationSeconds = 10 * 3600; // 10 hours in seconds
        if (durationInSeconds > maxDurationSeconds) {
          toast(t("this-clip-exceeds-the-8-h"), {
            autoClose: 3500,
            type: "error",
            theme: "light",
          });
          URL.revokeObjectURL(objectURL);
          selectedAudio.value.data = null;
          selectedAudio.value.name = "";
          return;
        }
        durationInUnits = Math.ceil(durationInSeconds / 30);
        computeAudioCost();
        URL.revokeObjectURL(objectURL);
      });
      selectedAudio.value.data =
        fileContent instanceof ArrayBuffer ? fileContent : null;
      selectedAudio.value.name = file.name;
    };
    reader.readAsArrayBuffer(file);
  }
};

function sttCostFromDeposit(minutes: number) {
  return minutes * servicesPricing.speechToText;
}

const computeAudioCost = async () => {
  try {
    computePricing.value = true;
    balanceNotEnough.value = false;
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "CONSUMEASYOUPAY") {
      const cost = sttCostFromDeposit(durationInUnits / 2);
      if (profileStore.userDeposit < cost) {
        const currentTimestamp = new Date(new Date().toISOString());
        const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
        if (currentTimestamp > subscriptionEndDate) {
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
        }
        const shortfallCost = cost - profileStore.userDeposit;
        const shortfallChars = Math.ceil(
          shortfallCost / servicesPricing.speechToText
        );
        if (shortfallChars > profileStore.speechToTextVolume) {
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
        } else {
          modalMessage.value = t("your-deposit-balance-is-not-enough");
          showPaymentModal.value = true;
        }
        balanceNotEnough.value = true;
      }
    } else {
      if (profileStore.speechToTextVolume < durationInUnits / 2) {
        const shortfallCost =
          durationInUnits / 2 - profileStore.speechToTextVolume;
        const shortfallChars = sttCostFromDeposit(shortfallCost);
        if (shortfallChars > profileStore.userDeposit) {
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
        } else {
          modalMessage.value = t("your-subscription-balance-is-not");
          showPaymentModal.value = true;
        }
        balanceNotEnough.value = true;
      }
    }
    computePricing.value = false;
  } catch (error) {
    console.log(error);
    computePricing.value = false;
    balanceNotEnough.value = false;
  }
};

const handleModalResponse = async (confirmed: boolean) => {
  showPaymentModal.value = false;
  if (confirmed) {
    balanceNotEnough.value = false;
    if (isPaymentProcessingLink.value) {
      await transcriptExterneAudio(true);
    }
  }
  isPaymentProcessingLink.value = false;
};

const handleFileChange = (event: any) => {
  const file = event.target.files[0];
  if (file.size > 500 * 1024 * 1024) {
    toast(t("error-file-size-exceeds-500mb"), {
      autoClose: 2500,
      type: "error",
      theme: "light",
    });
    return;
  }

  if (file && file.type.startsWith("audio/")) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileContent = e.target?.result;
      const audioElement = document.createElement("audio");
      const objectURL = URL.createObjectURL(file);
      audioElement.src = objectURL;
      audioElement.addEventListener("loadedmetadata", () => {
        const durationInSeconds = audioElement.duration;
        const maxDurationSeconds = 10 * 3600; // 10 hours in seconds
        if (durationInSeconds > maxDurationSeconds) {
          toast(t("this-clip-exceeds-the-8-h"), {
            autoClose: 3500,
            type: "error",
            theme: "light",
          });
          URL.revokeObjectURL(objectURL);
          selectedAudio.value.data = null;
          selectedAudio.value.name = "";
          return;
        }
        durationInUnits = Math.ceil(durationInSeconds / 30);
        computeAudioCost();
        URL.revokeObjectURL(objectURL);
      });
      selectedAudio.value.data =
        fileContent instanceof ArrayBuffer ? fileContent : null;
      selectedAudio.value.name = file.name;
    };
    durationInUnits;
    reader.readAsArrayBuffer(file);
  }
};

const handleCtrlX = (event: any) => {
  if (event.key === "x" && event.ctrlKey) {
    event.preventDefault();
    const inputElement = event.target;
    inputElement.select();
    document.execCommand("cut");
  }
};

const transcriptExterneAudio = async (extendPayment?: boolean) => {
  try {
    currentRequestId.value = "";
    if (!authStore.token || authStore.token.length == 0) {
      authStore.setAuthPop(true);
      return;
    }
    if (userInputAudioLink.value.trim().length == 0) {
      return;
    }
    if (originalLanguage.value.countryCode.length === 0) {
      toast(t("please-select-the-source-language-to"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    // handle the gdrive link
    // TODO at moment we dont support drive link
    /* if (isValidGoogleDriveLink(userInputAudioLink.value.trim())) {
      await transcriptGoogleDriveAudio();
      return;
    } */
    // other case
    if (
      !userInputAudioLink.value.toLowerCase().endsWith(".mp3") &&
      !userInputAudioLink.value.toLowerCase().endsWith(".wav") &&
      !userInputAudioLink.value.toLowerCase().endsWith(".m4a") &&
      !userInputAudioLink.value.toLowerCase().endsWith(".aac")
    ) {
      toast(t("the-provided-audio-link-is-not-an-mp3-wav-m4a-aac-file"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    processingLink.value = true;
    processingStarted.value = true;
    notReadyYet.value = false;
    processingStatus.value = t("send-a-request-to-the-server");

    const response = await fetch(transcriptExterneAudioUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        audioLink: userInputAudioLink.value,
        originalLang: originalLanguage.value.langCode,
        extendPayment,
      }),
    });
    const result = await response.json();
    console.log(result);

    if (result.error) {
      switch (result.error) {
        case "Authorization header missing":
        case "Invalid token":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "The balance is insufficient":
          const audioUnits = result.audioUnits || 0;
          if (userSubscription === "CONSUMEASYOUPAY") {
            const cost = sttCostFromDeposit(audioUnits / 2);
            const currentTimestamp = new Date(new Date().toISOString());
            const subscriptionEndDate = new Date(
              profileStore.subscriptionEndDate
            );
            if (currentTimestamp > subscriptionEndDate) {
              balanceNotEnough.value = true;
              toast(
                t("your-balance-is-insufficient-please-recharge-to-continue"),
                {
                  autoClose: 2500,
                  type: "error",
                  theme: "light",
                }
              );
              await new Promise((resolve) => setTimeout(resolve, 2500));
              window.location.reload();
              break;
            }

            const shortfallCost = cost - profileStore.userDeposit;
            const shortfallChars = Math.ceil(
              shortfallCost / servicesPricing.speechToText
            );
            if (shortfallChars > profileStore.speechToTextVolume) {
              balanceNotEnough.value = true;
              toast(
                t("your-balance-is-insufficient-please-recharge-to-continue"),
                {
                  autoClose: 2500,
                  type: "error",
                  theme: "light",
                }
              );
              await new Promise((resolve) => setTimeout(resolve, 2500));
              window.location.reload();
              break;
            }

            modalMessage.value = t("your-deposit-balance-is-not-enough");
            showPaymentModal.value = true;
            isPaymentProcessingLink.value = true;
            processingStarted.value = false;
            processingLink.value = false;
            break;
          } else {
            const shortfallCost =
              audioUnits / 2 - profileStore.speechToTextVolume;
            const shortfallChars = sttCostFromDeposit(shortfallCost);
            if (shortfallChars > profileStore.userDeposit) {
              balanceNotEnough.value = true;
              toast(
                t("your-balance-is-insufficient-please-recharge-to-continue"),
                {
                  autoClose: 2500,
                  type: "error",
                  theme: "light",
                }
              );
              await new Promise((resolve) => setTimeout(resolve, 2500));
              window.location.reload();
              break;
            }

            modalMessage.value = t("your-subscription-balance-is-not");
            showPaymentModal.value = true;
            processingStarted.value = false;
            isPaymentProcessingLink.value = true;
            processingLink.value = false;
            break;
          }
        case result.error
          .toLowerCase()
          .includes("audio duration exceeds maximum"):
          toast(t("this-clip-exceeds-the-8-h"), {
            autoClose: 3500,
            type: "warning",
            theme: "light",
          });
          processingStarted.value = false;
          processingLink.value = false;
          break;
        case result.error.toLowerCase().includes("duration"):
          toast(t("there-was-an-issue-processing-audio-link"), {
            autoClose: 3500,
            type: "error",
            theme: "light",
          });
          processingStarted.value = false;
          processingLink.value = false;
          break;
        default:
          toast(
            t('were-fixing-a-technical-issue-so-please-try'),
            {
              autoClose: 2500,
              type: "error",
              theme: "light",
            }
          );
          break;
      }
      processingStarted.value = false;
      processingLink.value = false;
      return;
    }

    processingStatus.value = t("retrieving-captions");

    // Handle both array and single object formats
    if (result.result && (Array.isArray(result.result) || (typeof result.result === 'object' && result.result !== null))) {
      receivedCaption.value = true;
      currentRequestId.value = result.request;
      originalJsonContent.value = JSON.stringify(result.result);
      
      // Normalize result to work with both formats
      let resultData = result.result;
      let isArrayFormat = Array.isArray(result.result);
      
      // If it's a single object, check if it's Soniox format
      if (!isArrayFormat && typeof result.result === 'object') {
        // Single object format - could be Soniox or Google Cloud
        if (isSonioxFormat(result.result)) {
          // Soniox single object format: {id, text, tokens}
          console.log("📝 Detected Soniox format (single object) - using Soniox parser");
          originalText.value = extractTextFromSoniox(result.result);
          defaultOriginalText.value = extractTextFromSoniox(result.result);
          prebuildAudioSubtitle.value = subtitleGenerationSoniox(result.result);
          originalAudioSubtitle.value = subtitleGenerationSoniox(result.result);
          defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(result.result);
          webVttData = subtitleGenerationSoniox(result.result);
          as.parsedCaptionsWithSpeakers = parseSonioxTranscription(result.result);
        } else {
          // Google Cloud single object - wrap in array
          const extractData = [result.result];
          originalText.value = extractText(extractData);
          defaultOriginalText.value = extractText(extractData);
          prebuildAudioSubtitle.value = subtitleGeneration(extractData);
          originalAudioSubtitle.value = subtitleGeneration(extractData);
          defaultOriginalAudioSubtitle.value = subtitleGeneration(extractData);
          webVttData = subtitleGeneration(extractData);
          as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(extractData);
        }
      } else if (isArrayFormat) {
        // Array format - check first element
        const firstResult = result.result[0];
        if (isSonioxFormat(firstResult)) {
          console.log("📝 Detected Soniox format (array) - using Soniox parser");
          originalText.value = extractTextFromSoniox(firstResult);
          defaultOriginalText.value = extractTextFromSoniox(firstResult);
          prebuildAudioSubtitle.value = subtitleGenerationSoniox(firstResult);
          originalAudioSubtitle.value = subtitleGenerationSoniox(firstResult);
          defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(firstResult);
          webVttData = subtitleGenerationSoniox(firstResult);
          as.parsedCaptionsWithSpeakers = parseSonioxTranscription(firstResult);
        } else {
          console.log("📝 Detected Google Cloud format (array) - using Google parser");
          originalText.value = extractText(result.result);
          defaultOriginalText.value = extractText(result.result);
          prebuildAudioSubtitle.value = subtitleGeneration(result.result);
          originalAudioSubtitle.value = subtitleGeneration(result.result);
          defaultOriginalAudioSubtitle.value = subtitleGeneration(result.result);
          webVttData = subtitleGeneration(result.result);
          as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(result.result);
        }
      }
      
      await profileStore.getUserSubscription(authStore.token!);
      //await translateText();
    } else {
      notReadyYet.value = true;
      /* setTimeout(() => {
        router.push("/");
      }, 3000); */
    }

    //processingLink.value = false;
    //processingStarted.value = false;
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox: any) => {
      if (checkbox.id === "none-checkbox") {
        checkbox.checked = true;
      }
    });
  } catch (error) {
    console.log(error);
    processingLink.value = false;
    processingStarted.value = false;
  }
};

const removeFile = () => {
  selectedAudio.value.name = "";
};

const navToPayment = () => {
  try {
    activitesStore.setComingFrom("audiotranscription");
    router.push("/pricing");
  } catch (error) {
    console.log("navToPayment", error);
  }
};

const selectTargetLanguage = async (lang: Language) => {
  if (lang.langCode == originalLanguage.value.langCode) {
    toast(t("original-and-translation-languages-must-be-different"), {
      autoClose: 1500,
      type: "error",
      theme: "light",
    });
    return;
  }
  translationLanguage.value = { ...lang };
  isTargetLanguageSelected.value = true;
  isTargetListOpen.value = false;
  closeList();
};

const startProcessing = async () => {
  try {
    if (!authStore.token || authStore.token.length == 0) {
      authStore.setAuthPop(true);
      return;
    }

    // One-time payment flow: same legacy UX (FFmpeg + progress bar + upload %) but one-time endpoints
    if (oneTimeUploadOrderId.value) {
      if (!selectedAudio.value.data || !selectedAudio.value.name) {
        toast(t("please-select-a-file") || "Please select a file", {
          autoClose: 2500,
          type: "error",
          theme: "light",
        });
        return;
      }
      if (!originalLanguage.value?.langCode) {
        toast(t("please-select-the-source-language-to"), {
          autoClose: 2500,
          type: "error",
          theme: "light",
        });
        return;
      }
      oneTimeUploadSourceLang.value = originalLanguage.value.langCode;
      const orderId = oneTimeUploadOrderId.value;
      const sourceLang = originalLanguage.value.langCode;

      ffmpegPercentage.value = 0;
      fileUploadPercentage.value = 0;
      progressBar.value = 0;
      receivedCaption.value = false;
      processingStarted.value = true;
      if (notReadyYet.value) notReadyYet.value = false;
      processingStatus.value = `${t("Audio_file_processing_in_progress")} ${ffmpegPercentage.value}%`;
      ffmpeg.on("log", ({ message }) => {
        console.log(message);
      });
      ffmpeg.on("progress", (progress) => {
        console.log(`Processing: ${Math.round(progress.progress * 100)}%`);
        ffmpegPercentage.value = Math.round(progress.progress * 100);
        progressBar.value = ffmpegPercentage.value;
        processingStatus.value = `${t("Audio_file_processing_in_progress")} ${ffmpegPercentage.value}%`;
      });
      if (!ffmpeg.loaded) {
        await ffmpeg.load({
          coreURL: await toBlobURL(
            `${ffmpegbaseURL}/ffmpeg-core.js`,
            "text/javascript"
          ),
          wasmURL: await toBlobURL(
            `${ffmpegbaseURL}/ffmpeg-core.wasm`,
            "application/wasm"
          ),
        });
      }
      const inputFileName = selectedAudio.value.name
        .split(".")
        .slice(0, -1)
        .join(".");
      const outputFileName = `${inputFileName}.wav`;
      await ffmpeg.writeFile(
        inputFileName,
        new Uint8Array(selectedAudio.value.data as ArrayBuffer)
      );
      await ffmpeg.exec([
        "-i",
        inputFileName,
        "-vn",
        "-acodec",
        "pcm_s16le",
        "-ar",
        "16000",
        "-ac",
        "1",
        outputFileName,
      ]);
      const outputData: any = await ffmpeg.readFile(outputFileName);
      progressBar.value = 0;
      const blob = new Blob([outputData], { type: "audio/wav" });
      processingStatus.value = `${t("uploading-audio-to-the-server")} ${fileUploadPercentage.value}%`;

      try {
        const urlRes = await fetch(
          `${API_BASE_URL}${ONETIME_AUDIO_UPLOAD_URL}?orderId=${encodeURIComponent(orderId)}`,
          { headers: { Authorization: `Bearer ${authStore.token}` } }
        );
        const urlData = await urlRes.json();
        if (!urlRes.ok) throw new Error(urlData.error || "Failed to get upload URL");
        const { url: signedUrl, fileName } = urlData;
        if (!signedUrl || !fileName) throw new Error("Failed to get upload URL");
        await uploadFileWithProgress(signedUrl, blob);
        const confirmRes = await fetch(`${API_BASE_URL}${ONETIME_AUDIO_CONFIRM_UPLOAD}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authStore.token}`,
          },
          body: JSON.stringify({ orderId, fileName, sourceLang, originalFileName: selectedAudio.value?.name || undefined }),
        });
        const confirmData = await confirmRes.json();
        if (!confirmRes.ok) throw new Error(confirmData.error || "Confirm failed");
        oneTimeUploadDone.value = true;
        notReadyYet.value = true;
      } catch (e) {
        const msg = (e as Error).message || "Upload failed";
        oneTimeUploadError.value = msg;
        toast(msg, {
          autoClose: 3500,
          type: "error",
          theme: "light",
        });
      } finally {
        if (!oneTimeUploadDone.value) processingStarted.value = false;
      }
      return;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }

    if (balanceNotEnough.value) {
      return;
    }
    if (originalLanguage.value.countryCode.length === 0) {
      toast(t("please-select-the-source-language-to"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    ffmpegPercentage.value = 0;
    fileUploadPercentage.value = 0;
    fileUploaded.value = false;
    progressBar.value = 0;
    receivedCaption.value = false;
    processingStarted.value = true;
    currentRequestId.value = "";
    if (notReadyYet.value) notReadyYet.value = false;
    processingStatus.value = `${t("Audio_file_processing_in_progress")} ${
      ffmpegPercentage.value
    }%`;
    ffmpeg.on("log", ({ message }) => {
      console.log(message);
    });
    ffmpeg.on("progress", (progress) => {
      console.log(`Processing: ${Math.round(progress.progress * 100)}%`);
      ffmpegPercentage.value = Math.round(progress.progress * 100);
      progressBar.value = ffmpegPercentage.value;
      processingStatus.value = `${t("Audio_file_processing_in_progress")} ${
        ffmpegPercentage.value
      }%`;
    });
    if (!ffmpeg.loaded) {
      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${ffmpegbaseURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${ffmpegbaseURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
      });
    }
    const inputFileName = selectedAudio.value.name
      .split(".")
      .slice(0, -1)
      .join(".");
    const outputFileName = `${inputFileName}.wav`;

    if (!selectedAudio.value.data) {
      return;
    }
    //const fileData = new Uint8Array(selectedAudio.value.data);
    //await ffmpeg.writeFile(inputFileName, fileData);

    await ffmpeg.writeFile(
      inputFileName,
      new Uint8Array(selectedAudio.value.data as ArrayBuffer)
    );

    await ffmpeg.exec([
      "-i",
      inputFileName,
      "-vn",
      "-acodec",
      "pcm_s16le",
      "-ar",
      "16000",
      "-ac",
      "1",
      outputFileName,
    ]);

    const outputData:any = await ffmpeg.readFile(outputFileName);
    progressBar.value = 0;
    /* const formData = new FormData();
    formData.append(
      "audioFile",
      new Blob([outputData], { type: "audio/wav" }),
      outputFileName
    );

    formData.append("languageCode", originalLanguage.value.langCode);
    formData.append("alternativeLanguageCodes", "");
    formData.append("requestType", "AUDIO");
    formData.append("duration", durationInUnits.toString()); */
    // Build query parameters for duplicate check and indicate Soniox transcription service
    const params = new URLSearchParams({
      originalname: selectedAudio.value.name,
      languageCode: originalLanguage.value.langCode,
      requestType: "AUDIO",
      transcriptionService: "soniox", // Indicate we're using Soniox
    });
    
    const response = await fetch(`${generateUploadUrl}?${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      if (data.error) {
        switch (true) {
          case data.error === "Invalid token":
          case data.error === "Authorization header missing":
            toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
              autoClose: 2500,
              type: "error",
              theme: "light",
            });
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/signing");
            break;
          case data.error?.includes("already processing"):
            toast(
              data.error || t("file-already-processing-please-wait"),
              {
                autoClose: 5000,
                type: "error",
                theme: "light",
              }
            );
            processingStarted.value = false;
            break;
          default:
            break;
        }
      }
      return;
    }
    const { url: signedUrl, fileName } = data;
    const blob = new Blob([outputData], { type: "audio/wav" });
    processingStatus.value = `${t("uploading-audio-to-the-server")} ${
      fileUploadPercentage.value
    }%`;
    /* const response = await fetch(transcriptAudioUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    }); */
    await uploadFileWithProgress(signedUrl, blob);
    const processData = {
      fileName,
      languageCode: originalLanguage.value.langCode,
      alternativeLanguageCodes: "",
      requestType: "AUDIO",
      originalname: selectedAudio.value.name,
    };

    const processRes = await fetch(transcriptAudioUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify(processData),
    });
    const result = await processRes.json();
    if (!processRes.ok) {
      console.log(result);
      if (result.error) {
        switch (true) {
          case result.error === "Authorization header missing":
          case result.error === "Invalid token":
            toast(
              t("your-session-has-expired-please-log-in-again-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/");
            break;

          case result.error === "The balance is insufficient":
            balanceNotEnough.value = true;
            toast(
              t(
                "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
              ),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            window.location.reload();
            break;

          default:
            toast(t('were-fixing-a-technical-issue-so-please-try'), {
              autoClose: 2500,
              type: "error",
              theme: "light",
            });
            await new Promise((resolve) => setTimeout(resolve, 2500));
            window.location.reload();
            break;
        }
      }
      return;
    }

    // Soniox endpoint returns immediately with job submission confirmation
    // Response format: { message: "Audio file uploaded successfully! {fileId}", fileId: "uuid-here", status: "submitted" }
    // Or: { message: "Request received. Processing your file...", fileName: "uuid.wav" }
    // Backend will send notification when transcription is complete (same as Google Cloud approach)
    if (result.status === "submitted" || result.fileId || 
        (result.message && (result.message.includes("uploaded successfully") || 
                            result.message.includes("Request received") || 
                            result.message.includes("Processing your file")))) {
      fileUploaded.value = true;
      // Store the fileId for later retrieval (notification will contain this)
      if (result.fileId) {
        currentRequestId.value = result.fileId;
      }
    } else if (result.message == "Success") {
      // Fallback for old format (if still supported)
      fileUploaded.value = true;
    } else {
      console.error("Error uploading audio file:", result);
      toast(t('were-fixing-a-technical-issue-so-please-try'), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      processingStarted.value = false;
      return;
    }

    // Set notReadyYet to show "comeback later" message
    // Backend will send notification when transcription is complete (webhook approach, same as Google)
    notReadyYet.value = true;
    /* setTimeout(() => {
      router.push("/");
    }, 3000); */
  } catch (error) {
    console.log(error);
  }
};

function isValidGoogleDriveLink(link: any) {
  const regex =
    /^https:\/\/(?:drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?id=|uc\?export=download&id=|drive\/folders\/|drive\/u\/\d\/folders\/)|docs\.google\.com\/(?:uc\?id=|document\/d\/|spreadsheets\/d\/|presentation\/d\/|forms\/d\/))([a-zA-Z0-9_-]+)/;
  return regex.test(link);
}

const transcriptGoogleDriveAudio = async () => {
  try {
    processingLink.value = true;
    processingStarted.value = true;
    notReadyYet.value = false;
    processingStatus.value = t("send-a-request-to-the-server");

    const response = await fetch(transcriptGoogleDriveAudioUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        gdriveLink: userInputAudioLink.value,
        originalLang: originalLanguage.value.langCode,
      }),
    });
    const result = await response.json();
    console.log(result);
    if (result.error) {
      processingLink.value = false;
      switch (result.error) {
        case "Authorization header missing":
        case "Invalid token":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/");
          break;
        case "The balance is insufficient":
          balanceNotEnough.value = true;
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 2500,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The provided audio link is not an supported audio file.":
          toast(t("the-provided-audio-link-is-not-an-mp3-wav-m4a-aac-file"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          processingStarted.value = false;
          await new Promise((resolve) => setTimeout(resolve, 2500));
          window.location.reload();
          break;
        default:
          toast(t('were-fixing-a-technical-issue-so-please-try'), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          processingStarted.value = false;
          await new Promise((resolve) => setTimeout(resolve, 2500));
          window.location.reload();
          break;
      }
    }
    processingStatus.value = t("retrieving-captions");
    if (Array.isArray(result.result)) {
      receivedCaption.value = true;
      currentRequestId.value = result.request;
      originalJsonContent.value = JSON.stringify(result.result);
      // Extract text based on format
      if (Array.isArray(result.result)) {
        const firstResult = result.result[0];
        if (isSonioxFormat(firstResult)) {
          originalText.value = extractTextFromSoniox(firstResult);
          defaultOriginalText.value = extractTextFromSoniox(firstResult);
        } else {
          originalText.value = extractText(result.result);
          defaultOriginalText.value = extractText(result.result);
        }
      } else if (result.result && typeof result.result === 'object') {
        if (isSonioxFormat(result.result)) {
          originalText.value = extractTextFromSoniox(result.result);
          defaultOriginalText.value = extractTextFromSoniox(result.result);
        } else {
          const extractData = [result.result];
          originalText.value = extractText(extractData);
          defaultOriginalText.value = extractText(extractData);
        }
      } else {
        originalText.value = extractText(result.result);
        defaultOriginalText.value = extractText(result.result);
      }
      
      // Detect format and use appropriate parser
      if (isSonioxFormat(result.result[0])) {
        console.log("📝 Detected Soniox format - using Soniox parser");
        prebuildAudioSubtitle.value = subtitleGenerationSoniox(result.result[0]);
        originalAudioSubtitle.value = subtitleGenerationSoniox(result.result[0]);
        defaultOriginalAudioSubtitle.value = subtitleGenerationSoniox(result.result[0]);
        webVttData = subtitleGenerationSoniox(result.result[0]);
        as.parsedCaptionsWithSpeakers = parseSonioxTranscription(result.result[0]);
      } else {
        console.log("📝 Detected Google Cloud format - using Google parser");
        prebuildAudioSubtitle.value = subtitleGeneration(result.result);
        originalAudioSubtitle.value = subtitleGeneration(result.result);
        defaultOriginalAudioSubtitle.value = subtitleGeneration(result.result);
        webVttData = subtitleGeneration(result.result);
        as.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(result.result);
      }
      await profileStore.getUserSubscription(authStore.token!);
      //await translateText();
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox: any) => {
        if (checkbox.id === "none-checkbox") {
          checkbox.checked = true;
        }
      });
    } else {
      notReadyYet.value = true;
      /* setTimeout(() => {
        router.push("/");
      }, 3000); */
    }
    //processingLink.value = false;
    //processingStarted.value = false;
  } catch (error) {
    console.log(error);
    processingLink.value = false;
    processingStarted.value = false;
  }
};

// New method to extract text from Soniox format
const extractTextFromSoniox = (sonioxData: any): string => {
  try {
    // Soniox format has text field directly
    if (sonioxData && typeof sonioxData === 'object' && sonioxData.text) {
      return sonioxData.text || "";
    }
    
    // If text field is not available, try to reconstruct from tokens
    if (sonioxData && sonioxData.tokens && Array.isArray(sonioxData.tokens)) {
      let text = "";
      sonioxData.tokens.forEach((token: any) => {
        if (token.text) {
          text += token.text;
        }
      });
      return text.trim();
    }
    
    return "";
  } catch (error) {
    console.error("Error extracting text from Soniox:", error);
    return "";
  }
};

// Original extractText method - kept unchanged for Google Cloud format
const extractText = (data: any) => {
  try {
    let concatenatedTranscript = "";
    
    // Google Cloud format
    if (data[0]?.results) {
      data[0].results.forEach((result: any) => {
        result.alternatives.forEach((alternative: any) => {
          concatenatedTranscript += alternative.transcript + " ";
        });
      });
    }

    return concatenatedTranscript;
  } catch (error) {
    console.log("extractText");
    console.log(error);
    return "";
  }
};

// Helper function to detect if response is Soniox format
function isSonioxFormat(data: any): boolean {
  // Soniox format has: id, text, tokens array
  // Google Cloud format has: results array with alternatives
  if (!data || typeof data !== 'object') {
    return false;
  }
  
  // Check if it's Soniox format (has id, text, and tokens array)
  if (data.id !== undefined && data.text !== undefined && Array.isArray(data.tokens)) {
    console.log("✅ Detected Soniox format: has id, text, and tokens");
    return true;
  }
  
  // Check if it's Google Cloud format (has results array with alternatives)
  if (data.results && Array.isArray(data.results) && data.results.length > 0) {
    if (data.results[0].alternatives && Array.isArray(data.results[0].alternatives)) {
      console.log("✅ Detected Google Cloud format: has results.alternatives");
      return false;
    }
  }
  
  // Check if it's Google Cloud format (array with results)
  if (Array.isArray(data) && data.length > 0 && data[0].results) {
    console.log("✅ Detected Google Cloud format: array with results");
    return false;
  }
  
  return false;
}

// Parse Soniox transcription format
function parseSonioxTranscription(sonioxResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (!sonioxResponse.tokens || !Array.isArray(sonioxResponse.tokens)) {
      console.warn("Soniox response missing tokens array");
      return captions;
    }

    let currentSpeaker: number | null = null;
    let currentStartTime = 0;
    let transcript = "";
    let speakerSegments: Array<{
      word: string;
      speakerTag: number | null;
      startTime: number;
    }> = [];

    // Group tokens into words (tokens can be partial words like "S", "o,", " wh", "at")
    // Strategy: Tokens with leading spaces start new words, tokens without continue current word
    const words: Array<{
      text: string;
      startMs: number;
      endMs: number;
      speaker: number | null;
    }> = [];
    
    let currentWord = "";
    let wordStartMs = 0;
    let wordEndMs = 0;
    let wordSpeaker: number | null = null;

    sonioxResponse.tokens.forEach((token: any, index: number) => {
      const tokenText = token.text || "";
      const tokenStartMs = token.start_ms || 0;
      const tokenEndMs = token.end_ms || 0;
      const tokenSpeaker = token.speaker !== null && token.speaker !== undefined ? token.speaker : null;

      // Check if token has leading space (indicates new word starts)
      const hasLeadingSpace = tokenText.trimStart() !== tokenText;
      const trimmedTokenText = tokenText.trimStart();
      
      // If token has leading space, it means a new word is starting
      if (hasLeadingSpace) {
        // Save previous word if it exists
        if (currentWord.trim()) {
          words.push({
            text: currentWord.trim(),
            startMs: wordStartMs,
            endMs: wordEndMs,
            speaker: wordSpeaker
          });
        }
        // Start new word
        currentWord = trimmedTokenText;
        wordStartMs = tokenStartMs;
        wordEndMs = tokenEndMs;
        wordSpeaker = tokenSpeaker;
      } else {
        // Continue current word
        if (!currentWord) {
          // First token of a word
          wordStartMs = tokenStartMs;
          wordSpeaker = tokenSpeaker;
        }
        currentWord += tokenText;
        wordEndMs = tokenEndMs;
        // Update speaker if this token has one
        if (tokenSpeaker !== null) {
          wordSpeaker = tokenSpeaker;
        }
      }
    });

    // Handle last word if exists
    if (currentWord.trim()) {
      words.push({
        text: currentWord.trim(),
        startMs: wordStartMs,
        endMs: wordEndMs,
        speaker: wordSpeaker
      });
    }
    
    console.log("🔵 Soniox: Grouped tokens into words:", words.length, "words");
    if (words.length > 0) {
      console.log("First few words:", words.slice(0, 5));
    }

    // Helper function to determine the most common speaker in a segment
    const getMostCommonSpeaker = (segments: Array<{speakerTag: number | null}>): number | null => {
      const speakerCounts: Record<number, number> = {};
      let maxCount = 0;
      let mostCommonSpeaker: number | null = null;

      segments.forEach(segment => {
        if (segment.speakerTag !== null && segment.speakerTag !== undefined) {
          speakerCounts[segment.speakerTag] = (speakerCounts[segment.speakerTag] || 0) + 1;
          if (speakerCounts[segment.speakerTag] > maxCount) {
            maxCount = speakerCounts[segment.speakerTag];
            mostCommonSpeaker = segment.speakerTag;
          }
        }
      });

      // If no speaker found, try to get the first non-null speaker
      if (mostCommonSpeaker === null) {
        const firstSpeaker = segments.find(s => s.speakerTag !== null && s.speakerTag !== undefined);
        if (firstSpeaker) {
          mostCommonSpeaker = firstSpeaker.speakerTag;
        }
      }

      return mostCommonSpeaker;
    };

    // Now process words into captions (similar to Google Cloud logic)
    if (words.length === 0) {
      console.warn("No words extracted from Soniox tokens");
      return captions;
    }
    
    console.log("🔵 Soniox: Processing", words.length, "words into captions");
    
    words.forEach((word, i) => {
      const wordStartSeconds = word.startMs / 1000;
      const nextWord = words[i + 1];
      const nextWordStartSeconds = nextWord ? (nextWord.startMs / 1000) : null;
      
      const wordText = word.text;
      const speakerTag = word.speaker;

      // Initialize start time for new caption
      if (transcript.trim() === "") {
        currentStartTime = wordStartSeconds;
        currentSpeaker = speakerTag;
      }

      // Check if speaker changed BEFORE adding word (important for multi-speaker captions)
      const speakerChanged = currentSpeaker !== null && speakerTag !== null && currentSpeaker !== speakerTag;
      
      // If speaker changed and we have some content, split the caption immediately
      if (speakerChanged && transcript.trim() !== "" && speakerSegments.length > 0) {
        const duration = wordStartSeconds - currentStartTime;
        // Split immediately on speaker change if we have at least 0.3 seconds of content
        if (duration >= 0.3) {
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(wordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: [...speakerSegments]
          };

          captions.push(newCaption);

          // Reset for new speaker
          currentStartTime = wordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag;
        }
      }

      // Add word to transcript
      transcript = transcript + " " + wordText;
      
      // Store word with speaker info for this segment
      speakerSegments.push({
        word: wordText,
        speakerTag: speakerTag,
        startTime: wordStartSeconds
      });

      // Update current speaker
      if (speakerTag !== null) {
        currentSpeaker = speakerTag;
      }
      
      // Check if we should create a caption chunk (based on duration only)
      if (nextWordStartSeconds !== null) {
        const duration = nextWordStartSeconds - currentStartTime;
        const ndnextWord = words[i + 2];
        const ndnextWordStartSeconds = ndnextWord ? (ndnextWord.startMs / 1000) : null;
        const ndDuration = ndnextWordStartSeconds 
          ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
          : null;

        // Split caption if:
        // 1. Duration is in the target range, OR
        // 2. Next duration would exceed max
        const shouldSplit = 
          (minBinSize <= duration && duration <= maxBinSize) ||
          (ndDuration && ndDuration > maxBinSize);

        if (shouldSplit) {
          // Determine the most common speaker for this caption
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(nextWordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: [...speakerSegments]
          };

          captions.push(newCaption);

          // Reset for next caption
          currentStartTime = nextWordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag; // Set to new speaker
        }
      }
    });

    // Handle remaining transcript
    if (transcript.trim() !== "" && words.length > 0) {
      const lastWord = words[words.length - 1];
      const lastWordEndSeconds = lastWord.endMs / 1000;
      const duration = lastWordEndSeconds - currentStartTime;

      if (duration > 0) {
        // Determine the most common speaker for this caption
        const captionSpeaker = getMostCommonSpeaker(speakerSegments);
        
        const newCaption: CaptionModel = {
          start: formatTime(currentStartTime),
          dur: formatTime(lastWordEndSeconds),
          text: transcript.trim(),
          speakerTag: captionSpeaker,
          words: [...speakerSegments]
        };
        captions.push(newCaption);
      }
    }
    
    console.log("🔵 Soniox: Generated", captions.length, "captions");
    if (captions.length > 0) {
      console.log("First caption:", captions[0]);
      console.log("First caption details:", {
        start: captions[0].start,
        dur: captions[0].dur,
        text: captions[0].text,
        speakerTag: captions[0].speakerTag,
        wordsCount: captions[0].words?.length || 0
      });
    }
    
    // ========== LOG PARSING SUMMARY ==========
    console.log("═══════════════════════════════════════════════════════════");
    console.log("📊 SONIOX PARSING SUMMARY");
    console.log("═══════════════════════════════════════════════════════════");
    console.log("Total tokens processed:", sonioxResponse.tokens?.length || 0);
    console.log("Total words extracted:", words.length);
    console.log("Total captions generated:", captions.length);
    console.log("═══════════════════════════════════════════════════════════");

    return captions;
  } catch (error) {
    console.error("Error parsing Soniox transcription:", error);
    return [];
  }
}

// Generate WebVTT from Soniox format
function subtitleGenerationSoniox(sonioxResponse: any): string {
  try {
    const captions = parseSonioxTranscription(sonioxResponse);
    
    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error generating WebVTT from Soniox:", error);
    return "";
  }
}

function parseTranscriptionWithSpeakers(speechToTextResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (speechToTextResponse[0]?.results) {
      speechToTextResponse[0].results.forEach((result: any) => {
        let currentSpeaker: number | null = null;
        let currentStartTime = 0;
        let transcript = "";
        let speakerSegments: Array<{
          word: string;
          speakerTag: number | null;
          startTime: number;
        }> = [];

        result.alternatives[0].words.forEach((wordData: any, i: number) => {
          const wordStartSeconds = parseFloat(wordData.startTime?.seconds || 0);
          const nextWord = result.alternatives[0].words[i + 1];
          const nextWordStartSeconds = nextWord 
            ? (parseFloat(nextWord.startTime?.seconds || 0)) 
            : null;
          
          const wordText = wordData.word;
          const speakerTag = wordData.speakerTag || null;

          // Initialize start time for new caption
          if (transcript.trim() === "") {
            currentStartTime = wordStartSeconds;
            currentSpeaker = speakerTag;
          }

          // Add word to transcript
          transcript = transcript + " " + wordText;
          
          // Store word with speaker info for this segment
          speakerSegments.push({
            word: wordText,
            speakerTag: speakerTag,
            startTime: wordStartSeconds
          });

          // Check if we should create a caption chunk
          if (nextWordStartSeconds !== null) {
            const duration = nextWordStartSeconds - currentStartTime;
            const ndnextWord = result.alternatives[0].words[i + 2];
            const ndnextWordStartSeconds = ndnextWord 
              ? (parseFloat(ndnextWord.startTime?.seconds || 0)) 
              : null;
            const ndDuration = ndnextWordStartSeconds 
              ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
              : null;

            if (
              (minBinSize <= duration && duration <= maxBinSize) ||
              (ndDuration && ndDuration > maxBinSize)
            ) {
              const newCaption: CaptionModel = {
                start: formatTime(currentStartTime),
                dur: formatTime(nextWordStartSeconds),
                text: transcript.trim(),
                speakerTag: currentSpeaker,
                words: [...speakerSegments]
              };

              captions.push(newCaption);

              // Reset for next caption
              currentStartTime = nextWordStartSeconds;
              transcript = "";
              speakerSegments = [];
            }
          }
        });

        // Handle remaining transcript
        if (transcript.trim() !== "") {
          const lastWord = result.alternatives[0].words[result.alternatives[0].words.length - 1];
          const lastWordEndSeconds = parseFloat(lastWord.endTime?.seconds || 0);
          const duration = lastWordEndSeconds - currentStartTime;

          if (duration > 0) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(lastWordEndSeconds),
              text: transcript.trim(),
              speakerTag: currentSpeaker,
              words: [...speakerSegments]
            };
            captions.push(newCaption);
          }
        }
      });
    }

    return captions;
  } catch (error) {
    console.error("Error parsing transcription with speakers:", error);
    return [];
  }
}

function subtitleGeneration(speechToTextResponse: any): string {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 2.5;
    const maxBinSize = 3.5;
    if (speechToTextResponse[0].results) {
      speechToTextResponse[0].results.forEach((result: any) => {
        let currentStartTime = 0;
        let transcript = "";
        let currentSpeaker: number | null = null;
        let speakerSegments: Array<{
          word: string;
          speakerTag: number | null;
          startTime: number;
        }> = [];

        for (let i = 0; i < result.alternatives[0].words.length; i++) {
          const wordData = result.alternatives[0].words[i];
          const word = wordData.word;
          const wordStartSeconds = wordData.startTime?.seconds || 0;
          const nextWordStartSeconds =
            result.alternatives[0].words[i + 1]?.startTime?.seconds || 0;
          const ndnextWordStartSeconds =
            result.alternatives[0].words[i + 2]?.startTime?.seconds || 0;
          const speakerTag = wordData.speakerTag || null;

          if (transcript.trim() === "") {
            currentStartTime = wordStartSeconds;
            currentSpeaker = speakerTag;
          }

          transcript = transcript + " " + word;
          
          // Store word with speaker info for this segment
          speakerSegments.push({
            word: word,
            speakerTag: speakerTag,
            startTime: wordStartSeconds
          });

          const duration = nextWordStartSeconds - currentStartTime;
          const ndDuration =
            ndnextWordStartSeconds - nextWordStartSeconds + duration;

          if (
            (minBinSize <= duration && duration <= maxBinSize) ||
            ndDuration > maxBinSize
          ) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(nextWordStartSeconds),
              text: transcript.trim(),
              speakerTag: currentSpeaker,
              words: [...speakerSegments]
            };
            captions.push(newCaption);
            currentStartTime = nextWordStartSeconds;
            transcript = "";
            speakerSegments = [];
          }
        }

        if (transcript.trim() !== "") {
          const lastWord = result.alternatives[0].words[
            result.alternatives[0].words.length - 1
          ];
          const lastWordEndSeconds = lastWord.endTime?.seconds || 0;
          const duration = lastWordEndSeconds - currentStartTime;

          if (duration > 0) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(lastWordEndSeconds),
              text: transcript.trim(),
              speakerTag: currentSpeaker,
              words: [...speakerSegments]
            };
            captions.push(newCaption);
          }
        }
      });
    }

    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error processing captions:", error);
    return "";
  }
}

const uploadFileWithProgress = (url: string, blob: any) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open("PUT", url, true);
    xhr.setRequestHeader("Content-Type", "audio/wav"); // GCS expects this for signed URLs

    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        fileUploadPercentage.value = Math.round(
          (event.loaded * 100) / event.total
        );
        processingStatus.value = `${t("uploading-audio-to-the-server")} ${
          fileUploadPercentage.value
        }%`;
        progressBar.value = fileUploadPercentage.value;
      }
    });

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ message: "File uploaded to GCS" });
      } else {
        reject(new Error(`Failed to upload file: ${xhr.statusText}`));
      }
    };

    xhr.onerror = () =>
      reject(new Error("An error occurred during the file upload."));

    xhr.send(blob);
  });
};

function formatTime(seconds: number): string {
  const date = new Date(seconds * 1000);
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const secondsFormatted = date.getSeconds().toString().padStart(2, "0");
  const milliseconds = (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
  return `${hours}:${minutes}:${secondsFormatted}.${milliseconds}`;
}

// Title is set by the route/page component, not by this reusable component

function resetOneTimeState() {
  showOneTimePayPanel.value = false;
  oneTimeUploadOrderId.value = null;
  oneTimeResultPendingOrderId.value = null;
  oneTimeUploadSourceLang.value = "";
}

defineExpose({ resetOneTimeState });
</script>
